/* OVELA STUDIO · Ajustes del mentor (oct-nov 2026)
   - Franja roja de campaña con fases semanales («El frío no espera» → Black Friday)
   - Etiqueta de descuento redondeada en tarjetas de producto
   - Ficha de producto: etiqueta de precio especial, garantía de devolución
     y ayuda en los desplegables, fotos más rápidas y deslizables */
(function () {
  'use strict';

  /* Toda la campaña se configura en snippets/ovela-campaign-bar.liquid (window.OVELA_CAMPAIGN) */
  var CAMPAIGN = window.OVELA_CAMPAIGN || {};
  var PRICE_LABEL = CAMPAIGN.priceLabel || 'Precio especial';
  var POPUP_ID = CAMPAIGN.popupId || '';
  var PHASES = CAMPAIGN.phases || [];

  function currentPhase() {
    var now = Date.now();
    for (var i = 0; i < PHASES.length; i++) {
      var end = new Date(PHASES[i].until).getTime();
      if (now < end) return { phase: PHASES[i], end: end };
    }
    return null;
  }

  function initCampaignBar() {
    var clock = document.getElementById('ovelaHwClock');
    var main = document.getElementById('ovelaNovMain');
    if (!clock || !main || clock.dataset.ovelaBound === 'true') return;
    clock.dataset.ovelaBound = 'true';

    var kicker = document.getElementById('ovelaNovKicker');
    var title = document.getElementById('ovelaNovTitle');
    var ends = document.getElementById('ovelaNovEnds');
    var timer = main.querySelector('.ovela-hw-timer');
    var d = clock.querySelector('[data-hw="d"]');
    var dSep = clock.querySelector('[data-hw="dsep"]');
    var h = clock.querySelector('[data-hw="h"]');
    var m = clock.querySelector('[data-hw="m"]');
    var s = clock.querySelector('[data-hw="s"]');
    var active = null;
    var interval = null;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function apply() {
      active = currentPhase();
      if (!active) {
        /* Campaña terminada: franja de rebajas sin reloj */
        if (kicker) kicker.textContent = 'Ovela Studio';
        if (title) title.textContent = 'Rebajas de temporada';
        if (timer) timer.hidden = true;
        main.setAttribute('href', '/collections/rebajas');
        main.setAttribute('aria-label', 'Rebajas de temporada');
        if (interval) clearInterval(interval);
        return;
      }
      var p = active.phase;
      if (kicker) kicker.textContent = p.kicker;
      if (title) title.textContent = p.main;
      if (ends) ends.textContent = p.ends;
      if (timer) timer.hidden = false;
      main.setAttribute('href', p.href);
      main.setAttribute('aria-label', p.kicker + '. ' + p.main + '. ' + p.ends + ' ' + new Date(active.end).toLocaleDateString('es-ES'));
    }

    function tick() {
      if (!active) return;
      var left = Math.max(0, Math.floor((active.end - Date.now()) / 1000));
      if (left === 0) {
        apply();
        if (!active) return;
        left = Math.max(0, Math.floor((active.end - Date.now()) / 1000));
      }
      var days = Math.floor(left / 86400);
      if (d) d.textContent = String(days);
      if (d) d.hidden = days === 0;
      if (dSep) dSep.hidden = days === 0;
      if (h) h.textContent = pad(Math.floor((left % 86400) / 3600));
      if (m) m.textContent = pad(Math.floor((left % 3600) / 60));
      if (s) s.textContent = pad(left % 60);
    }

    main.addEventListener('click', function (e) {
      if (!active || !active.phase.popup || !POPUP_ID) return;
      e.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', POPUP_ID]);
    });

    apply();
    tick();
    interval = setInterval(tick, 1000);
  }

  /* ===================================================
     ETIQUETA -X% EN TARJETAS DE PRODUCTO (colecciones, búsqueda)
     =================================================== */
  function parseEuros(text) {
    var clean = String(text || '').replace(/[^\d,.]/g, '');
    if (!clean) return 0;
    /* 1.299,00 → 1299.00 · 99,00 → 99.00 */
    clean = clean.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    return parseFloat(clean) || 0;
  }

  function badgeCards(root) {
    (root || document).querySelectorAll('[ref="priceContainer"]').forEach(function (container) {
      if (container.closest('#ovela-p') || container.querySelector('.ovela-price-badge')) return;
      var compareEl = container.querySelector('.compare-at-price');
      var priceEl = container.querySelector('.price');
      if (!compareEl || !priceEl) return;
      var compare = parseEuros(compareEl.textContent);
      var price = parseEuros(priceEl.textContent);
      if (!(compare > price && price > 0)) return;
      var badge = document.createElement('span');
      badge.className = 'ovela-price-badge ovela-price-badge--card';
      badge.textContent = '-' + Math.round((1 - price / compare) * 100) + '%';
      container.appendChild(badge);
    });
  }

  function initCardBadges() {
    badgeCards(document);
    if (!('MutationObserver' in window)) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        badgeCards(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ===================================================
     FICHA DE PRODUCTO
     =================================================== */
  function initProductPage() {
    var root = document.getElementById('ovela-p');
    if (!root || root.dataset.ovelaMentor === 'true') return;
    root.dataset.ovelaMentor = 'true';

    /* 1 · Etiqueta de precio especial bajo el precio (solo si la prenda está rebajada) */
    var priceBox = root.querySelector('.ov-price');
    var oldPrice = root.querySelector('#ov-old');
    if (priceBox && !root.querySelector('.ov-hw-label')) {
      var label = document.createElement('p');
      label.className = 'ov-hw-label ovela-hw-label';
      label.textContent = PRICE_LABEL;
      priceBox.appendChild(label);

      var syncLabel = function () {
        label.hidden = !oldPrice || oldPrice.style.display === 'none';
      };
      syncLabel();
      if (oldPrice && 'MutationObserver' in window) {
        new MutationObserver(syncLabel).observe(oldPrice, { attributes: true, attributeFilter: ['style'] });
      }
    }

    /* 2 · Desplegables: garantía de devolución primero + ayuda que lleva a contacto */
    var accord = root.querySelector('.ov-accord');
    if (accord && !accord.querySelector('[data-ovela-guarantee]')) {
      var guarantee = document.createElement('div');
      guarantee.className = 'ov-acc';
      guarantee.setAttribute('data-ovela-guarantee', '');
      guarantee.innerHTML =
        '<button type="button"><span>GARANTÍA DE DEVOLUCIÓN · 30 DÍAS</span><b>+</b></button>' +
        '<div class="ov-acc-content">' +
          '<p>Si la prenda no te convence, tienes <strong>30 días desde que la recibes</strong> para devolverla.</p>' +
          '<p>Solo tienes que escribirnos con tu número de pedido y te indicamos los pasos. Los gastos de envío de la devolución corren a cargo de la clienta.</p>' +
          '<a href="/pages/politica-de-devoluciones" class="ov-policy-link">Ver política de devoluciones →</a>' +
        '</div>';

      var help = document.createElement('div');
      help.className = 'ov-acc';
      help.setAttribute('data-ovela-help', '');
      help.innerHTML =
        '<button type="button"><span>¿NECESITAS AYUDA?</span><b>+</b></button>' +
        '<div class="ov-acc-content">' +
          '<p>¿Dudas con la talla, el envío o tu pedido? Escríbenos y te respondemos lo antes posible.</p>' +
          '<a href="/pages/contact" class="ov-help-btn">Contactar con nosotras →</a>' +
        '</div>';

      accord.insertBefore(help, accord.firstChild);
      accord.insertBefore(guarantee, help);

      [guarantee, help].forEach(function (acc) {
        var btn = acc.querySelector('button');
        btn.addEventListener('click', function () {
          acc.classList.toggle('open');
          btn.querySelector('b').textContent = acc.classList.contains('open') ? '−' : '+';
        });
      });
    }

    /* 3 · Fotos más fluidas: precarga + fundido corto + deslizar en móvil */
    var mainImg = root.querySelector('#ov-main-img');
    var mainBox = root.querySelector('.ov-main');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.ov-thumb'));

    if (mainImg && thumbs.length) {
      var cache = {};
      var preload = function (url) {
        if (!url || cache[url]) return;
        var im = new Image();
        im.decoding = 'async';
        im.src = url;
        cache[url] = im;
      };

      /* Precarga todas las fotos grandes cuando la página ya está libre */
      var warmAll = function () {
        thumbs.forEach(function (t) { preload(t.dataset.img); });
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(warmAll, { timeout: 1500 });
      } else {
        setTimeout(warmAll, 600);
      }
      thumbs.forEach(function (t) {
        t.addEventListener('pointerenter', function () { preload(t.dataset.img); });
        t.addEventListener('touchstart', function () { preload(t.dataset.img); }, { passive: true });
      });

      /* Fundido rápido al cambiar de foto */
      var lastSrc = mainImg.getAttribute('src');
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          var src = mainImg.getAttribute('src');
          if (src === lastSrc) return;
          lastSrc = src;
          mainImg.classList.add('is-swapping');
          var done = function () { mainImg.classList.remove('is-swapping'); };
          if (mainImg.complete) {
            requestAnimationFrame(done);
          } else {
            mainImg.addEventListener('load', done, { once: true });
            mainImg.addEventListener('error', done, { once: true });
          }
        }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
      }

      /* Deslizar la foto principal para pasar a la siguiente / anterior */
      if (mainBox) {
        var startX = 0;
        var startY = 0;
        mainBox.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        }, { passive: true });
        mainBox.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - startX;
          var dy = e.changedTouches[0].clientY - startY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          var visible = thumbs.filter(function (t) { return !t.classList.contains('ov-hidden'); });
          var current = visible.findIndex(function (t) { return t.classList.contains('active'); });
          if (current < 0) current = 0;
          var next = dx < 0 ? current + 1 : current - 1;
          if (next < 0) next = visible.length - 1;
          if (next >= visible.length) next = 0;
          if (visible[next]) visible[next].click();
        }, { passive: true });
      }
    }
  }

  /* ===================================================
     PAGO ACELERADO EN LA FICHA (Shop Pay / Apple Pay / Google Pay)
     Sustituye al antiguo "Comprar ahora", que solo llevaba al checkout.
     Se mantiene sincronizado con el color, la talla y la cantidad elegidos.
     =================================================== */
  function initProductAccelerated() {
    var box = document.getElementById('ovelaPdpAccel');
    var root = document.getElementById('ovela-p');
    var dataEl = document.getElementById('ovelaPdpData');
    if (!box || !root || !dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var buyRow = root.querySelector('.ov-buyrow');
    var buyNow = root.querySelector('#ov-now');
    if (!buyRow) return;

    buyRow.parentNode.insertBefore(box, buyRow.nextSibling);
    box.classList.remove('is-parked');
    if (buyNow) buyNow.hidden = true;

    var idInput = box.querySelector('input[name="id"]');
    var qtyInput = box.querySelector('input[name="quantity"]');
    var lock = document.getElementById('ovelaPdpAccelLock');

    function optionIndex(words) {
      var names = (data.options || []).map(function (o) {
        return String(o.name || o).toLowerCase();
      });
      for (var i = 0; i < names.length; i++) {
        for (var w = 0; w < words.length; w++) {
          if (names[i].indexOf(words[w]) > -1) return i;
        }
      }
      return -1;
    }

    var ci = optionIndex(['color', 'colour']);
    var si = optionIndex(['talla', 'size']);

    function textOf(id) {
      var el = root.querySelector(id);
      return el ? el.textContent.trim() : '';
    }

    function sync() {
      var color = ci >= 0 ? textOf('#ov-color') : null;
      var sizeText = si >= 0 ? textOf('#ov-size') : null;
      var sizeChosen = si < 0 || (sizeText && sizeText.toLowerCase() !== 'elige talla');

      var variant = (data.variants || []).find(function (v) {
        return (ci < 0 || v.options[ci] === color) && (si < 0 || v.options[si] === sizeText);
      });

      if (variant && idInput) idInput.value = variant.id;
      if (qtyInput) qtyInput.value = Math.max(1, parseInt(textOf('#ov-qty'), 10) || 1);

      var ready = !!(sizeChosen && variant && variant.available);
      box.classList.toggle('is-locked', !ready);
      if (lock) {
        lock.hidden = ready;
        lock.textContent = sizeChosen && variant && !variant.available
          ? 'Talla agotada'
          : 'Elige tu talla para pagar en un clic';
      }
    }

    /* Los selectores de la ficha cambian el texto de color/talla/cantidad: lo seguimos */
    root.addEventListener('click', function () {
      setTimeout(sync, 0);
    });

    if (lock) {
      lock.addEventListener('click', function () {
        var sizes = root.querySelector('.ov-sizes');
        if (!sizes) return;
        sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizes.classList.remove('ov-sizes--nudge');
        void sizes.offsetWidth;
        sizes.classList.add('ov-sizes--nudge');
      });
    }

    sync();
  }

  function init() {
    initCampaignBar();
    initProductPage();
    initProductAccelerated();
    initCardBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();